"use client";

import * as React from "react";
import { LifeBuoy, ArrowRight, Settings2 } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "What does a 'turnkey' AV solution include?",
  answer: "Our turnkey approach means we handle your entire project from concept to completion. This includes custom AV design, hardware procurement, system integration, professional installation, and final testing. We can also incorporate necessary low voltage, data, and electrical services, providing a single point of contact for your entire technology deployment."
}, {
  question: "Do you provide support for existing AV infrastructure?",
  answer: "Yes. Our engineering team can evaluate your current systems and provide integration services to upgrade or expand your capabilities. Whether you need to add direct view LED video walls to a boardroom or upgrade a public address system, we ensure seamless operation with your existing technology."
}, {
  question: "What types of facilities do you service?",
  answer: "We specialize in a wide range of environments requiring precision integration. This includes corporate boardrooms, training facilities, command and control centers, healthcare environments, government courthouses, houses of worship, and large-scale hospitality or casino venues."
}, {
  question: "How do you handle system maintenance and troubleshooting?",
  answer: "We offer comprehensive post-installation support to ensure your systems operate at peak performance. Our technical support team is equipped to handle troubleshooting, routine maintenance, and system updates for all integrated hardware, from video conferencing setups to complex sound masking systems."
}, {
  question: "Can you integrate room scheduling with our current calendar system?",
  answer: "Absolutely. We design and deploy room scheduling solutions that integrate directly with standard enterprise calendar platforms (like Microsoft 365 or Google Workspace), providing real-time availability displays and streamlined booking processes right at the meeting space entrance."
}];
export default function SupportFaq() {
  return <section id="support-faq" className="dark bg-background text-foreground py-20 px-4 md:px-8 lg:px-12 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-card border border-border rounded-xl mb-6 shadow-sm">
            <Settings2 className="size-6 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Technical Support & FAQ
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg">
            Find answers to common questions about our custom audiovisual integration, installation processes, and ongoing system support.
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-2xl p-4 md:p-8 shadow-lg">
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border bg-card rounded-lg overflow-hidden data-[state=open]:border-primary/50 transition-colors duration-200 shadow-sm">
                <AccordionTrigger className="px-5 py-4 hover:no-underline data-[state=open]:text-primary font-semibold tracking-tight text-left transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-5 pb-5 pt-1 text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between bg-card border border-border rounded-xl p-6 md:p-8 shadow-sm">
          <div className="flex items-center gap-4 mb-6 sm:mb-0">
            <div className="bg-primary/10 p-3 rounded-full">
              <LifeBuoy className="size-6 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Still need assistance?</h3>
              <p className="text-sm text-muted-foreground">
                Our engineering team is ready to help with your specific requirements.
              </p>
            </div>
          </div>
          <Link to="/ContactPage">
            <Button size="lg" className="w-full sm:w-auto group">
              Contact Technical Support
              <ArrowRight className="ml-2 size-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}